import LoginPageImage from '@/components/_core/ui/auth-page-image/index.vue';
import HeaderDefault from '@/components/_core/ui/header/index.vue';

export default {
  middleware : '_core/anonymous',
  components : {
    HeaderDefault,
    LoginPageImage
  }
};
